const CreateUser = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontSize: '2rem',
      }}
    >
      Si cette fonctionnalité vous interesse, <br />
      parlez-en à un Product Owner
    </div>
  );
};

export default CreateUser;
